export default {
      id: "ic_chevron-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_chevron-usage",
      toString: function () {
        return this.url;
      }
    }